import { ActionFunction } from 'react-router-dom'

import ApiRoutes from '@utils/api-routes'
import http from '@utils/http'

const deleteCollectionAction: ActionFunction = async ({ request }) => {
  const formData = await request.formData()
  const collectionId = formData.get('collectionId')
  if (!collectionId) {
    return null
  }

  return http.action.post(ApiRoutes.collections.deletePath(), {
    collection_id: collectionId,
  })
}

export default deleteCollectionAction
